import type { ReactNode } from 'react';

type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  action?: ReactNode;
};

export const SectionHeading = ({ eyebrow, title, description, action }: SectionHeadingProps) => (
  <div className="flex flex-col gap-5 border-b border-border pb-5">
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary">{eyebrow}</p>
      <h1 className="mt-2 text-[28px] font-semibold leading-[1.2] tracking-[-0.025em] text-foreground">{title}</h1>
      {description ? <p className="mt-3 max-w-2xl text-sm leading-6 text-muted-foreground">{description}</p> : null}
    </div>
    {action ? <div className="w-full [&_a]:w-full [&_button]:w-full">{action}</div> : null}
  </div>
);
